import { render, staticRenderFns } from "./Medium.vue?vue&type=template&id=6b150ba2"
import script from "./Medium.vue?vue&type=script&lang=js"
export * from "./Medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports